// extracted by mini-css-extract-plugin
export default {"element":"element_element__7Uflx","isDragging":"element_isDragging__G8jXi","dragHandleWrapper":"element_dragHandleWrapper__Qd1n5","dragHandle":"element_dragHandle__gdyvZ"};